import apiService from "services/api";
import { useQuery } from "react-query";

const useLeanStudentQuery = (selectedStudents) =>
  useQuery(
    ["selectedStudentsData", selectedStudents],
    () =>
      Promise.all(
        selectedStudents.map((student) => apiService.student.getLean(student)),
      ),
    {
      enabled: Boolean(selectedStudents?.length),
    },
  );

export const useStudentPmrQuery = (studentId) => {
  return useQuery({
    queryKey: ["studentPmr", studentId ?? 0],
    queryFn: () => apiService.studentPmr.get(studentId ?? 0),
    enabled: !!studentId,
  });
};

export default useLeanStudentQuery;
